// extracted by mini-css-extract-plugin
module.exports = {"tableCellWrapper":"styles_tableCellWrapper__1Pev9","highlightedCell":"styles_highlightedCell__1Vdhd"};